import { loadingPlaceholder } from "./MailListItemMeetingPreview.locstring.json";
import loc from "owa-localize";
import type { JSX } from "react";
export default function renderMeetingPreviewPlaceHolder(): JSX.Element {
    return <span>{loc(loadingPlaceholder)}</span>;
}
